import { useState } from "react";

function Paso3({
  RECOM_MB,
  MAX_MB,
  imagenesUI,
  dropzonesImagenes,
  divisaServicio,
  BotonesaPasos,
  setPasoActual,
  guardarProgreso,
}) {
  const [imagenExpandida, setImagenExpandida] = useState(null);

  return (
    <div className="card border-0 shadow-sm mb-4">
      <div className="card-body">
        {/* PASO */}
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
          <div>
            <h5 className="mb-1">Paso 3</h5>
            <small className="text-muted">Sube fotografías del servicio</small>
          </div>
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <span className="badge rounded-pill border" style={{ backgroundColor: "var(--color-bg-accent-subtle)", color: "var(--color-text-primary)", borderColor: "var(--azul-cielo)", fontWeight: 600 }}>
              {divisaServicio === "USD" ? "🇺🇸 USD" : "🇨🇴 COP"}
            </span>
            <span className="badge text-bg-primary">3 / 5</span>
          </div>
        </div>

        {/* TITULO */}
        <h3 className="mt-3">Fotos</h3>
        <div className="alert alert-info mb-3" role="alert">
          <strong>Solo necesitas subir 1 foto para publicar.</strong> Te recomendamos subir las 8 — los servicios con más fotos reciben más reservas.
          <br /><small className="text-muted">Recomendado: cuadradas (1:1), 1000-1200px, menos de {RECOM_MB}MB. Máximo: {MAX_MB}MB.</small>
        </div>



        {/* IMÁGENES */}
        <div className="filaImagenesScroll">
          {dropzonesImagenes.map(({ index, getRootProps, getInputProps }) => {
            const img = imagenesUI[index];
            return (
              <div {...getRootProps()} className="cajaImagen cajaImagenScroll" key={index}>
                <input {...getInputProps()} />
                {img?.preview ? (
                  <div style={{ position: 'relative', width: '100%', height: '100%', borderRadius: '8px', overflow: 'hidden' }}>
                    <img src={img.preview} alt="Previsualización" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    {img.analizando && (
                      <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(var(--negro-rgb), 0.5)', color: 'var(--blanco)', fontWeight: 600, fontSize: '10px', textAlign: 'center', padding: '0.3rem' }}>
                        Analizando...
                      </div>
                    )}
                    {!img.analizando && (
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          setImagenExpandida(img.preview);
                        }}
                        title="Ver imagen completa"
                        style={{ position: 'absolute', top: 4, right: 4, width: 24, height: 24, borderRadius: '50%', border: 'none', backgroundColor: 'rgba(var(--negro-rgb), 0.55)', color: 'var(--blanco)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0, zIndex: 2 }}
                      >
                        <i className="bi bi-arrows-fullscreen" style={{ fontSize: 11 }}></i>
                      </button>
                    )}
                  </div>
                ) : (
                  <p>Arrastra o haz clic para subir</p>
                )}
              </div>
            );
          })}
        </div>
        <small className="text-muted d-block mt-1">Desliza para ver todas las fotos →</small>

        {/* Navegación Paso 3 */}
        <BotonesaPasos
          anterior={() => setPasoActual(2)}
          siguiente={() => setPasoActual(4)}
          onGuardar={(incluirPaquetes) => guardarProgreso({ mostrarAlerta: true, incluirPaquetes })}
          incluirPaquetesEnGuardar={false}
        />

        {/* LIGHTBOX: ver imagen completa */}
        {imagenExpandida && (
          <div
            onClick={() => setImagenExpandida(null)}
            style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(var(--negro-rgb), 0.85)', zIndex: 1050, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem', cursor: 'zoom-out' }}
          >
            <button
              type="button"
              onClick={(e) => { e.stopPropagation(); setImagenExpandida(null); }}
              title="Cerrar"
              style={{ position: 'absolute', top: 16, right: 16, width: 36, height: 36, borderRadius: '50%', border: 'none', backgroundColor: 'rgba(var(--blanco-rgb), 0.15)', color: 'var(--blanco)', fontSize: 18, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
              <i className="bi bi-x-lg"></i>
            </button>
            <img
              src={imagenExpandida}
              alt="Vista completa"
              onClick={(e) => e.stopPropagation()}
              style={{ maxWidth: '90vw', maxHeight: '90vh', objectFit: 'contain', borderRadius: 8 }}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default Paso3;
